(() => {
  if (window.__pdlDrawerShippingBound) return;
  window.__pdlDrawerShippingBound = true;

  const root = window.Shopify?.routes?.root || '/';
  const zipKey = 'pdl-cart-shipping-zip';
  const modalId = 'pdl-shipping-result-modal';

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };

  const cartSignature = (cart) => JSON.stringify({
    items: cart.items.map((item) => [item.key, item.quantity]),
    price: cart.total_price
  });

  const destinationFor = async (zip) => {
    const params = new URLSearchParams({
      'shipping_address[zip]': zip,
      'shipping_address[country]': 'Brazil'
    });

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3500);
      let response;
      try {
        response = await fetch(`https://viacep.com.br/ws/${zip}/json/`, {
          signal: controller.signal
        });
      } finally {
        clearTimeout(timeout);
      }
      if (response.ok) {
        const address = await response.json();
        if (!address.erro && address.uf && address.localidade) {
          params.set('shipping_address[province]', address.uf);
          params.set('shipping_address[city]', address.localidade);
        }
      }
    } catch (_) {
      // CEP e país continuam suficientes para tentar a consulta.
    }
    return params.toString();
  };

  const fetchRates = async (params) => {
    const prepare = await fetch(`${root}cart/prepare_shipping_rates.json?${params}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!prepare.ok) throw new Error('prepare');

    for (let attempt = 0; attempt < 25; attempt += 1) {
      if (attempt) await new Promise((resolve) => setTimeout(resolve, 900));
      const response = await fetch(`${root}cart/async_shipping_rates.json?${params}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('rates');
      const result = await response.json();
      if (result && Array.isArray(result.shipping_rates)) return result.shipping_rates;
    }
    throw new Error('timeout');
  };

  const setStatus = (container, message) => {
    const status = container.querySelector('[data-pdl-cart-shipping-status]');
    if (!status) return;
    status.textContent = message;
    status.hidden = !message;
  };

  const ensureModalStyles = () => {
    if (document.getElementById('pdl-shipping-result-modal-styles')) return;

    const style = document.createElement('style');
    style.id = 'pdl-shipping-result-modal-styles';
    style.textContent = `
      #${modalId} {
        position: fixed !important;
        inset: 50% auto auto 50% !important;
        transform: translate(-50%, -50%) !important;
        width: min(430px, calc(100vw - 32px)) !important;
        max-width: 430px !important;
        max-height: min(72vh, 620px) !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        border: 0 !important;
        border-radius: 18px !important;
        background: #fff !important;
        color: #212121 !important;
        box-shadow: 0 24px 70px rgb(0 0 0 / 0.28) !important;
        font-family: "Barlow", var(--font-body--family), Arial, sans-serif !important;
      }

      #${modalId}::backdrop {
        background: rgb(0 0 0 / 0.42);
        backdrop-filter: blur(1px);
      }

      #${modalId} .pdl-shipping-popup__panel {
        display: flex;
        flex-direction: column;
        max-height: min(72vh, 620px);
        background: #fff;
      }

      #${modalId} .pdl-shipping-popup__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        padding: 20px 20px 14px;
        border-bottom: 1px solid #ececec;
      }

      #${modalId} .pdl-shipping-popup__eyebrow {
        display: inline-flex;
        align-items: center;
        min-height: 24px;
        margin-bottom: 7px;
        padding: 3px 8px;
        border-radius: 999px;
        background: #f6c500;
        color: #212121;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
      }

      #${modalId} .pdl-shipping-popup__title {
        margin: 0;
        color: #212121;
        font-size: 20px;
        font-weight: 700;
        line-height: 1.15;
      }

      #${modalId} .pdl-shipping-popup__subtitle {
        margin: 5px 0 0;
        color: #737373;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.35;
      }

      #${modalId} .pdl-shipping-popup__close {
        display: grid;
        place-items: center;
        flex: 0 0 38px;
        width: 38px;
        height: 38px;
        margin: -5px -5px 0 0;
        padding: 0;
        border: 0;
        border-radius: 999px;
        background: #f4f4f2;
        color: #212121;
        font-size: 25px;
        font-weight: 300;
        line-height: 1;
        cursor: pointer;
      }

      #${modalId} .pdl-shipping-popup__body {
        overflow-y: auto;
        padding: 14px 20px 20px;
      }

      #${modalId} .pdl-shipping-popup__rates {
        display: grid;
        gap: 8px;
        margin: 0;
        padding: 0;
        list-style: none;
      }

      #${modalId} .pdl-shipping-popup__rate {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        min-height: 50px;
        margin: 0;
        padding: 11px 13px;
        border: 1px solid #e8e8e6;
        border-radius: 11px;
        background: #fff;
      }

      #${modalId} .pdl-shipping-popup__rate-name {
        min-width: 0;
        color: #212121;
        font-size: 13.5px;
        font-weight: 400;
        line-height: 1.25;
      }

      #${modalId} .pdl-shipping-popup__rate-price {
        flex: 0 0 auto;
        color: #212121;
        font-size: 14px;
        font-weight: 700;
        white-space: nowrap;
      }

      #${modalId} .pdl-shipping-popup__rate.is-free {
        border-color: #212121;
        border-left: 3px solid #f6c500;
        background: #212121;
      }

      #${modalId} .pdl-shipping-popup__rate.is-free .pdl-shipping-popup__rate-name {
        color: #fff;
        font-weight: 600;
      }

      #${modalId} .pdl-shipping-popup__rate.is-free .pdl-shipping-popup__rate-price {
        padding: 5px 9px;
        border-radius: 999px;
        background: #f6c500;
        color: #212121;
        font-size: 12px;
      }

      #${modalId} .pdl-shipping-popup__note {
        margin: 13px 1px 0;
        color: #7a7a7a;
        font-size: 11.5px;
        font-weight: 400;
        line-height: 1.4;
      }

      @media screen and (max-width: 749px) {
        #${modalId} {
          width: calc(100vw - 24px) !important;
          max-height: 76vh !important;
          border-radius: 16px !important;
        }

        #${modalId} .pdl-shipping-popup__panel {
          max-height: 76vh;
        }

        #${modalId} .pdl-shipping-popup__header {
          padding: 18px 17px 13px;
        }

        #${modalId} .pdl-shipping-popup__body {
          padding: 12px 17px 17px;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getModal = () => {
    ensureModalStyles();
    let dialog = document.getElementById(modalId);
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = modalId;
    dialog.setAttribute('aria-labelledby', `${modalId}-title`);
    dialog.innerHTML = `
      <div class="pdl-shipping-popup__panel">
        <div class="pdl-shipping-popup__header">
          <div>
            <span class="pdl-shipping-popup__eyebrow">CARRINHO INTEIRO</span>
            <h2 class="pdl-shipping-popup__title" id="${modalId}-title">Opções de frete</h2>
            <p class="pdl-shipping-popup__subtitle" data-pdl-shipping-popup-subtitle></p>
          </div>
          <button type="button" class="pdl-shipping-popup__close" aria-label="Fechar opções de frete" data-pdl-shipping-popup-close>×</button>
        </div>
        <div class="pdl-shipping-popup__body">
          <ul class="pdl-shipping-popup__rates" data-pdl-shipping-popup-rates></ul>
          <p class="pdl-shipping-popup__note">Estimativa de frete para o valor atual do carrinho. Confirme valores e prazos no checkout.</p>
        </div>
      </div>
    `;

    dialog.querySelector('[data-pdl-shipping-popup-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    document.body.appendChild(dialog);
    return dialog;
  };

  const formatZip = (zip) => zip.length === 8 ? `${zip.slice(0, 5)}-${zip.slice(5)}` : zip;

  const showRatesPopup = (rates, cart, zip) => {
    const dialog = getModal();
    const list = dialog.querySelector('[data-pdl-shipping-popup-rates]');
    const subtitle = dialog.querySelector('[data-pdl-shipping-popup-subtitle]');
    if (!list || !subtitle) return;

    subtitle.textContent = `Frete para o CEP ${formatZip(zip)}`;
    list.replaceChildren();

    for (const rate of rates) {
      const amount = Number(rate.price);
      const isFree = Number.isFinite(amount) && amount === 0;
      const item = document.createElement('li');
      item.className = `pdl-shipping-popup__rate${isFree ? ' is-free' : ''}`;

      const label = document.createElement('span');
      label.className = 'pdl-shipping-popup__rate-name';
      label.textContent = rate.presentment_name || rate.name || 'Entrega';

      const price = document.createElement('strong');
      price.className = 'pdl-shipping-popup__rate-price';
      price.textContent = isFree
        ? 'Grátis'
        : Number.isFinite(amount)
          ? new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: rate.currency || cart.currency || 'BRL'
            }).format(amount)
          : '';

      item.append(label, price);
      list.appendChild(item);
    }

    if (!dialog.open) dialog.showModal();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-pdl-cart-shipping-form]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();

    const container = form.closest('[data-pdl-cart-shipping]');
    const input = form.querySelector('[data-pdl-cart-shipping-zip]');
    const button = form.querySelector('[data-pdl-cart-shipping-submit]');
    const list = container?.querySelector('[data-pdl-cart-shipping-rates]');
    if (!container || !input || !button || button.disabled) return;

    const zip = input.value.replace(/\D/g, '');
    if (list) {
      list.replaceChildren();
      list.hidden = true;
    }

    if (zip.length !== 8) {
      setStatus(container, 'Digite um CEP válido com 8 números.');
      input.focus();
      return;
    }

    button.disabled = true;
    button.textContent = 'Calculando...';
    setStatus(container, 'Consultando o frete para todos os itens do carrinho...');

    try {
      try { sessionStorage.setItem(zipKey, zip); } catch (_) { /* armazenamento indisponível */ }
      const before = await getCart();
      if (!before.item_count) throw new Error('empty');
      const params = await destinationFor(zip);
      const rates = await fetchRates(params);
      const after = await getCart();
      if (!container.isConnected) return;
      if (cartSignature(before) !== cartSignature(after)) throw new Error('changed');

      if (!rates.length) {
        setStatus(container, 'Não há opções de entrega para este CEP e os itens do carrinho.');
        return;
      }

      // O resultado não ocupa espaço no carrinho lateral: abre em uma janela sobre o drawer.
      setStatus(container, '');
      showRatesPopup(rates, after, zip);
    } catch (error) {
      if (!container.isConnected) return;
      setStatus(container, error.message === 'changed'
        ? 'O carrinho mudou. Consulte o frete novamente.'
        : 'Não foi possível consultar o frete agora. Tente novamente ou consulte em /cart.');
    } finally {
      if (container.isConnected) {
        button.disabled = false;
        button.textContent = 'CONSULTAR';
      }
    }
  }, true);

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pdl-drawer-clear-cart]');
    if (!button || button.disabled) return;
    if (!window.confirm('Tem certeza que deseja remover todos os itens do carrinho?')) return;

    button.disabled = true;
    button.textContent = 'Limpando...';
    try {
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('clear');
      window.location.reload();
    } catch (_) {
      button.disabled = false;
      button.textContent = 'Limpar carrinho';
      window.alert('Não foi possível limpar o carrinho. Tente novamente.');
    }
  });

  const restoreZip = () => {
    let zip;
    try { zip = sessionStorage.getItem(zipKey); } catch (_) { return; }
    if (!zip) return;
    document.querySelectorAll('[data-pdl-cart-shipping-zip]').forEach((input) => {
      if (!input.value) input.value = zip;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreZip, { once: true });
  } else {
    restoreZip();
  }

  const header = document.getElementById('header-group');
  if (header) new MutationObserver(restoreZip).observe(header, { childList: true, subtree: true });
})();
